import { GenericObject } from '@dxb-web-ui-framework/common/types';

const getContextPreloadedDataByProperties = (properties: string[], context: GenericObject) => {
  const preloadedData = {} as GenericObject;
  const contextEntries = Object.entries(context);

  for (const propertyValue of properties) {
    for (const [key, value] of contextEntries) {
      if (key === propertyValue) {
        preloadedData[key] = value;
      }
    }
  }

  return preloadedData;
};

export { getContextPreloadedDataByProperties };
